($ => {

  function getTextWidth(text, font, UC) {
    var f = font;
    if(UC){
      var o = $('<span>' + text + '</span>')
        .css({'font': f, 'float': 'left', 'white-space': 'nowrap', 'display':'block', 'text-transform': 'uppercase' })
        .appendTo($('body'));
    }else{
      var o = $('<span>' + text + '</span>')
        .css({'font': f, 'float': 'left', 'white-space': 'nowrap', 'display':'block'})
        .appendTo($('body'));
    }

    var w = o.width();

    o.remove();

    return w;
  }

  $.fn.selectizeTooltip = function () {
    this.on('mouseenter', function () {
      var $this = $(this);
      var item, title, extra_space;
      if ($this.hasClass('selectize-input')) {
        item = $this.find('.item');

        title =item.text();
        //.item padding-right: 20px + selectize-input padding-right: 35px + selectize-input padding-left: 12px
        extra_space = 67;
        if (this.offsetWidth  < (getTextWidth(title, $this.css('font'), $this.is('th')) + extra_space)) {
          if ($this.data && !$this.data('bs.tooltip')) {
            $this.tooltip({
              title: title,
              placement: 'bottom',
              container: 'body',
              trigger: 'manual',
            });
            $this.tooltip('show');
          }
        }
      }else{
        var options = $this.children();

        if(!$._data(options[0], "events")){
          $.each( options, function(index, option) {
            $(option).on('mouseenter', function () {
              var $this = $(this);
              var title, extra_space;

              title = $this.text();
              //.option padding-right: 12px + .option padding-left: 12px
              extra_space = 24;
              if (this.offsetWidth  < (getTextWidth(title, $this.css('font'), $this.is('th')) + extra_space)) {
                if ($this.data && !$this.data('bs.tooltip')) {
                  $this.tooltip({
                    title: title,
                    placement: 'bottom',
                    container: 'body',
                    trigger: 'manual',
                  });
                  $this.tooltip('show');
                }
              }
            });
            $(option).on('mouseleave', function () {
              var $this = $(this);
              if ($this.data && $this.data('bs.tooltip')) {
                $this.tooltip('destroy');
              }
            });
          });
        }
      }

    });

    this.on('mouseleave', function () {
      var $this = $(this);
      if ($this.data && $this.data('bs.tooltip')) {
        $this.tooltip('destroy');
      }
    });
  };
})(jQuery);


// WEBPACK FOOTER //
// ./source/assets/javascripts/plugins/selectize-tooltip.js